import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { useQuery, useApi } from "../../hooks";
import { LoadingIndicator, NoResults, Pagination } from "../../shared";
import LearningResourcesSearchForm from "../LearningResourcesSearchForm";
import LearningResourcesResults from "./LearningResourcesResults";
import { scrollToRef } from "../../helpers";

const LearningResourcesSearchPage = ({ filters }) => {
  const [query, setQuery] = useQuery();
  const [state, fetch, fetchNextPage] = useApi("/api/v1/publications");
  const scrollRef = useRef(null);

  const { isLoading, isError, records, meta, pagination } = state;

  useEffect(() => {
    fetch({ type: "learning_resource", ...query });
  }, [query]); // eslint-disable-line

  useEffect(() => {
    if (isLoading) scrollToRef(scrollRef);
  }, [isLoading]);

  function handleSubmit(values) {
    setQuery({ type: "learning_resource", ...query, ...values });
  }

  return (
    <div ref={scrollRef}>
      <LearningResourcesSearchForm
        onSubmit={handleSubmit}
        filters={filters}
        query={query}
      />
      <div aria-live="assertive">
        {records && records.length > 0 && (
          <>
            <LearningResourcesResults records={records} total={meta.total} />
            {pagination.totalPages > 1 && (
              <Pagination
                totalPages={pagination.totalPages}
                currentPage={pagination.currentPage}
              />
            )}
          </>
        )}
        {isLoading && <LoadingIndicator />}
        {!isLoading && !isError && meta && meta.total === 0 && <NoResults />}
        {!isLoading && isError && <NoResults isError />}
      </div>
    </div>
  );
};

LearningResourcesSearchPage.propTypes = {
  filters: PropTypes.object,
};

export default LearningResourcesSearchPage;
